export default __webpack_public_path__ + "static/media/slide1.acc32c45.png";